import { BASE_API_CONFIG } from "../../util/Api";
import { NETWORK_METHOD } from "../../util/ApiHelper";

export const MY_EXIM_API_EXPORTER_OFFER_PRODUCTS = {
  createExporterOfferProduct: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/exporter-offer-products`,
    data: params.data,
  }),
  updateExporterOfferProduct: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/exporter-offer-products/${params?.id}`,
    data: params.data,
  }),
  getExporterOfferProductList: (params) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/exporter-offer-products?page=${params?.page}&limit=${params?.limit}`,
    params: {
      page: params.page,
      limit: params.limit,
    },
  }),
  getExporterOfferProductById: (param) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/exporter-offer-products/${param?.id}`,
  }),
  deleteExporterOfferProduct: (param) => ({
    method: NETWORK_METHOD.DELETE,
    url: `${BASE_API_CONFIG.baseURL}/exporter-offer-products/${param?.id}`,
  }),
  getOfferProductsListBuyer: (params) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/exporter-offer-products/buyer?page=${params?.page}&limit=${params?.limit}`,
    params: {
      page: params.page,
      limit: params.limit,
    },
  }),
  getBuyerOfferProductById: (param) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/exporter-offer-products/buyer/${param?.id}`,
  }),
};
